import React from 'react';
import { makeStyles } from '@mui/styles';
import {
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Toolbar,
  Box,
  TableHead,
} from '@mui/material';
import API from 'common/api';
import {
  Link,
  useLocation, useParams,
} from 'react-router';
import { PlaceHolderText } from 'components/PlaceholderCard/PlaceholderCard';
import Progress from 'components/Progress/Progress';
import useList from 'hooks/useList';
import { Card, Typography } from 'bso-ui';
import radioBackboneList from './radioBackboneList';
import RadioStatus from './components/RadioStatus';

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3)
  }
}));

const RadioList = () => {
  const classes = useStyles();
  const { id } = useParams();
  const height = '100vh';
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const backbone = radioBackboneList.find((item) => item.id.toString() === id) || {};
  const query = {
    storeKey: `radios-${id}`,
    apiEndpoint: `${API.RADIO}?backbone=${backbone?.name}`,
  };
  const [{
    data, isLoading, isError,
  }] = useList(query.storeKey, query.apiEndpoint, params, { refetchInterval: 60000 });

  if (!id || !['1', '2', '3'].includes(id)) {
    return (
      <div style={{ height: `calc(${height} - 100px)` }}>
        <PlaceHolderText variant="h3" content="Please select backbone" height="100%" />
      </div>
    );
  }

  if (isError) {
    return (
      <div style={{ height: `calc(${height} - 100px)` }}>
        <PlaceHolderText variant="h3" content="Error fetching radios" height="100%" />
      </div>
    );
  }

  const renderData = () => (
    <Card id="RadiosCard">
      <CardContent>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell><Typography variant="subtitle1">Circuit</Typography></TableCell>
              <TableCell><Typography variant="subtitle1">Status</Typography></TableCell>
            </TableRow>
          </TableHead>
          {data.results?.length > 0
            && (
            <TableBody>
              {data.results.map((item) => (
                <TableRow
                  className={classes.tableRow}
                  hover
                  key={item.id}
                >
                  <TableCell>
                    <Link to={`/radios/${id}/devices/${item.name}`}>
                      <Typography color="#5959ea" variant="body2">
                        {item.name}
                      </Typography>
                    </Link>
                  </TableCell>
                  <RadioStatus circuit={item.name} />
                </TableRow>
              ))}
            </TableBody>
            )}
        </Table>
      </CardContent>
    </Card>
  );

  return (
    <div className={classes.root}>
      <Toolbar style={{ display: 'flex', alignItems: 'center' }}>
        <Typography id="SwitchesTitle" variant="h2" color="primary">Radios_</Typography>
        <span style={{ flex: 1 }} />
      </Toolbar>
      {!isLoading && id && data
        ? (
          <Box p={3}>
            {renderData()}
          </Box>
        ) : <Progress />}

    </div>
  );
};

export default RadioList;
